module.exports = __webpack_public_path__ + "static/assets/ca38505c5d6a1966ca49ed280c2bc447.png";